// @ts-nocheck
import React , {useEffect , useState} from 'react';
import Slide from '@mui/material/Slide';
import Grid from '@mui/material/Grid';
import Typography from '@mui/material/Typography';
import Accordion from '@mui/material/Accordion';
import AccordionItem from "./AccordionItem";
import makeStyles from '@mui/styles/makeStyles';
import SinapThemev2 from "../styles/SinapThemev2";
import AccordionSummary from '@mui/material/AccordionSummary';
import AccordionDetails from '@mui/material/AccordionDetails';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';



const useStyles = makeStyles((theme) => ({
    root: {
        '&:hover': {
            transform:
                `scale(1.01,1.01)`,
            transition: `transform 150ms`
        }
    }}));

export default function AccordionGrado({noticias , onClick, checked, titulo}) {


  return (
      <Accordion style={{width: "100%"}}>
          <AccordionSummary  expandIcon={<ExpandMoreIcon />} aria-controls="panel1a-content" id="panel1a-header" >
              <Typography variant='h6'  color={SinapThemev2.palette.primary.main}>{titulo}</Typography>
          </AccordionSummary>
          <AccordionDetails>
              {noticias.length === 0 ?
                  <Typography >No hay noticias</Typography>
                  :
                  noticias.map((notice , index) =>
                  <Slide key={index} direction="right" in={checked} mountOnEnter unmountOnExit>
                      <Grid item style={{width: "100%"}}>
                          <AccordionItem info={notice} onClick={onClick}/>
                      </Grid>
                  </Slide>
              )}
          </AccordionDetails>
      </Accordion>
  );
}